import React from 'react';
import {
  downloadRemoteFile,
  ensureFilenameExtension,
} from '../../utils/download';

type FileDownloadLinkProps = {
  href?: string | null;
  fileName?: string | null;
  contentType?: string | null;
  className?: string;
  title?: string;
  children?: React.ReactNode;
  fallbackExt?: string;
  onError?: (message: string) => void;
};

/**
 * Download link that forces a correct filename/extension even for cross-origin
 * storage URLs (where the HTML download attribute is ignored by browsers).
 */
export function FileDownloadLink({
  href,
  fileName,
  contentType,
  className,
  title,
  children,
  fallbackExt = '.pdf',
  onError,
}: FileDownloadLinkProps) {
  if (!href) return null;

  const label = children ?? fileName ?? 'Download';
  const safeName = ensureFilenameExtension(
    fileName || 'download',
    contentType,
    fallbackExt,
  );

  return (
    <button
      type="button"
      title={title || safeName}
      className={className}
      onClick={() => {
        void downloadRemoteFile(href, safeName, {
          contentType: contentType || undefined,
          fallbackExt,
        }).catch((err: unknown) => {
          const message = err instanceof Error ? err.message : 'Download failed';
          onError?.(message);
        });
      }}
    >
      {label}
    </button>
  );
}
